import { combineReducers } from 'redux';
import compose, * as fromCompose from './compose';
import execute, * as fromExecute from './execute';

export default combineReducers({
  execute,
  compose,
});

export const getColumns = (state) => fromCompose.getColumns(state.compose);

export const getEvent = (state) => fromCompose.getEvent(state.compose);

export const getUserFilter = (state) => fromCompose.getUserFilter(state.compose);

export const getIdUsingTemplate = (state) => fromCompose.getIdUsingTemplate(state.compose);

export const isAggregateEnabled = (state) => fromCompose.isAggregateEnabled(state.compose);

export const getUsersSQL = (state) => fromCompose.getUsersSQL(state.compose);

export const getError = (state) => fromCompose.getError(state.compose);

export const getExecutionEvent = (state) => fromExecute.getEvent(state.execute);

export const isExecuting = (state) => fromExecute.isExecuting(state.execute);

export const getExecuteId = (state) => fromExecute.getExecuteId(state.execute);
